import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { LangLink } from './LangLink';
// Pequeña función para poner en mayúscula la primera letra del username
const capitalize = (s) => {
  if (typeof s !== 'string' || !s) return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

/**
 * Componente reutilizable para mostrar la información del usuario.
 * Muestra el displayName si existe, con el @username debajo.
 * Si no hay displayName, muestra el username capitalizado.
 * Es un enlace al perfil del usuario.
 */
const UserDisplayInfo = ({ user, textClasses = {}, link = true }) => {
  if (!user || !user.username) {
    return null;
  }

  const mainName = user.displayName || capitalize(user.username);
  const subName = `@${user.username}`;

  // Clases por defecto que se pueden sobreescribir
  const mainNameClass =
    textClasses.main || 'font-bold text-neutral-800 dark:text-white truncate';
  const subNameClass =
    textClasses.sub ||
    'text-sm text-neutral-500 dark:text-neutral-400 truncate';

  const content = (
    <>
      <p className={mainNameClass}>{mainName}</p>
      <p className={subNameClass}>{subName}</p>
    </>
  );

  if (link) {
    return (
      <LangLink to={`/u/${user.username}`} className="group hover:no-underline">
        {content}
      </LangLink>
    );
  }

  return <div>{content}</div>;
};

UserDisplayInfo.propTypes = {
  user: PropTypes.shape({
    username: PropTypes.string.isRequired,
    displayName: PropTypes.string,
  }),
  textClasses: PropTypes.shape({
    main: PropTypes.string,
    sub: PropTypes.string,
  }),
  link: PropTypes.bool,
};

export default UserDisplayInfo;
